import firebase from 'firebase/app'
import { funcRegion, useEmulator } from '../config'
import { getByYearAndMonth } from './budgets'

export async function getById(year, month, itemId, userId) {
  const budget = await getByYearAndMonth(year, month, userId)
  return budget.items.find(item => item.id === itemId) || {}
}

export function save(item, itemId) {
  const func = firebase.app().functions(funcRegion)

  if (useEmulator) {
    func.useEmulator('localhost', 5000)
  }

  if (itemId) {
    const saveItem = func.httpsCallable('item-update')
    return saveItem({ item, id: itemId })
  }

  const saveItem = func.httpsCallable('item-save')
  return saveItem(item)
}

export async function removeById(year, month, itemId) {
  const func = firebase.app().functions(funcRegion)

  if (useEmulator) {
    func.useEmulator('localhost', 5000)
  }

  const removeItem = func.httpsCallable('item-remove')
  return removeItem({ year, month, id: itemId })
}
